export enum PrepUIErrorCode {
  FAILED_TO_REQUEST_SIMPLE_PREP = "FAILED_TO_REQUEST_SIMPLE_PREP",
  FAILED_TO_REMOVE_SIMPLE_PREP = "FAILED_TO_REMOVE_SIMPLE_PREP",
}
